// @flow
import { selectHasOwnerOnly } from '@gandi/cart';

import { mustCartOwnerBeReseller } from 'src/Cart/AccountChoice/modules/helpers';
import { selectCartOwners } from 'src/Cart/AccountChoice/modules/selectors';
import { useAppSelector } from 'src/hooks/useAppSelector';

export function useResellerOnlyAlert(): {
  ownerMustReseller: boolean,
} {
  const ownerOnly = useAppSelector(selectHasOwnerOnly);
  const cartOwners = useAppSelector(selectCartOwners);

  // $FlowFixMe[incompatible-call] PartialOrganization should be compatible with CartOwnerCandidate
  // $FlowFixMe[prop-missing]
  const ownerMustReseller = mustCartOwnerBeReseller(ownerOnly, cartOwners);
  return { ownerMustReseller };
}
